import React from 'react';
import AppRoutes from './routes/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import '../src/assets/styles/index.css';

function App() {
  return (
    <div className="App">
      <AppRoutes />
      <ToastContainer hideProgressBar />
    </div>
  );
}

export default App;
